// extracted by mini-css-extract-plugin
export default {"display-1":"card_display-1__9-JxI","white":"card_white__QMxSt","card":"card_card__3AVdS","darker":"card_darker__8w0vC"};